import { useFormik } from 'formik';
import * as Yup from 'yup';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { useEffect, } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { ErrorWord, TemplateProps, yapStringWhen } from '../common';
import { CheckBoxItemType } from 'views/templates/module/checkInput';
import { InvestorCategoryInfo, InvestorCategoryInfoStrs, InvestorCategory } from 'views/utils/enums';
import { formErrorScroll } from 'views/mutual/formErrorScroll';

export type InvestorCategoryInfoType = {
  investorCategoryInfo: CheckBoxItemType[]
};

export const useInvestorCategoryInfo = ({ isUpdate }: TemplateProps) => {
  const { param, add } = useCorporateAccountEstablishStore();
  const { setAccountOpenProfileDetailsPageType, setPreviousPage, } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const arraySchema = Yup.object().shape({
    label: Yup.string(),
    checked: Yup.boolean(),
  });
  const validation = Yup.object().shape({
    investorCategoryInfo: Yup.array()
      .of(arraySchema)
      .test('ArrayCheck', ErrorWord.SELECT_ONE_OR_MORE, (list) => list?.some((item) => item.checked)),
  });

  const initialValues: InvestorCategoryInfoType = {
    investorCategoryInfo: InvestorCategoryInfoStrs.map<CheckBoxItemType>((data) => {
      return { label: data, checked: param.investorCategoryInfo?.find((x) => x.label === data)?.checked ?? false };
    }),
  };

  const formik = useFormik<InvestorCategoryInfoType>({
    enableReinitialize: isUpdate,
    initialValues,
    async onSubmit() {
      add({
        ...param,
        ...formik.values,
      });
      const otherState = formik.values.investorCategoryInfo.find((item) => item.label === InvestorCategoryInfo.Other);
      if(otherState?.checked){
        setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.tfAuthentication);
        setPreviousPage(CorporateAccountOpenProfileDetailsPages.investorCategoryInfo)
        add({
          ...param,
          ...{
            ...formik.values,
            investorCategory: InvestorCategory.SpecificInvestor,
            consentDate : '',
          },
        });
      }
      else{
        setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.selectGeneralInvestor)
      }
    },
    validationSchema: validation,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const porps = {
    items: formik.values.investorCategoryInfo,
    onChangeItems: (items: CheckBoxItemType[]) => {
      formik.setFieldValue('investorCategoryInfo', items);
    },
    error: formik.errors.investorCategoryInfo as string,
  };

  useEffect(() => {
    formErrorScroll();
  }, [formik.isSubmitting]);

  useEffect(() => {
    const updateDisabledState = () => {
      const allUnchecked = formik.values.investorCategoryInfo.every((item) => !item.checked);
      const otherState = formik.values.investorCategoryInfo.find((item) => item.label === InvestorCategoryInfo.Other);


      const updatedPurpose = formik.values.investorCategoryInfo.map((item) => {
        if (allUnchecked) {
          return { ...item, disabled: false };
        }
        return { ...item, disabled: item.label === InvestorCategoryInfo.Other ? !otherState?.checked : otherState?.checked};
      });

      if (JSON.stringify(formik.values.investorCategoryInfo) !== JSON.stringify(updatedPurpose)) {
        formik.setFieldValue('investorCategoryInfo', updatedPurpose);
      }
    };

    updateDisabledState();

  }, [formik.values.investorCategoryInfo]);

  return {
    formik,
    porps,
  };
};
